document.addEventListener("DOMContentLoaded", function () {
  console.log("ADD-ON JS LOADED");

  function getMainQty() {
    const qty = document.querySelector('section[id^="MainProduct-"] input[name="quantity"]');
    const val = qty ? parseInt(qty.value, 10) : 1;
    return Number.isFinite(val) && val > 0 ? val : 1;
  }

  function setAddonState(card, selected) {
    const checkbox = card.querySelector(".js-addon-check");
    const button = card.querySelector(".js-addon-toggle");

    if (!checkbox || !button) return;

    checkbox.checked = selected;
    card.dataset.selected = selected ? "true" : "false";

    button.textContent = selected ? "Remove" : "Add";
    button.classList.toggle("lr-addon-card__btn--added", selected);

    const modal = document.getElementById("lr-addon-modal");
    const modalBtn = modal?.querySelector(".js-modal-addon-toggle");

    if (modalBtn && modal.dataset.activeAddonCard === card.dataset.addonKey) {
      modalBtn.textContent = selected ? "Remove" : "Add";
      modalBtn.classList.toggle("lr-addon-card__btn--added", selected);
    }
  }

  function getMainVariantIndex() {
  const variantInput = document.querySelector('section[id^="MainProduct-"] form[action^="/cart/add"] input[name="id"]');
  if (!variantInput) return 0;

  const currentVariantId = variantInput.value;

  const optionInputs = [
    ...document.querySelectorAll('section[id^="MainProduct-"] input[type="radio"]:checked')
  ];

  if (optionInputs.length === 0) return 0;

  const checkedInput = optionInputs[0];
  const groupInputs = [
    ...document.querySelectorAll(`input[name="${CSS.escape(checkedInput.name)}"]`)
  ];

  const index = groupInputs.findIndex(input => input.value === checkedInput.value);

  return index >= 0 ? index : 0;
}

function getAddonVariantId(card) {
  const variantIds = (card.dataset.upsellVariantIds || "")
    .split(",")
    .map(id => id.trim())
    .filter(Boolean);

  if (!variantIds.length) {
    return Number(card.dataset.upsellVariantId);
  }

  const mainIndex = getMainVariantIndex();

  const flippedIndex = mainIndex === 0 ? 1 : 0;
  return Number(variantIds[flippedIndex] || variantIds[0]);
}

  function toggleAddon(card) {
    const checkbox = card.querySelector(".js-addon-check");
    if (!checkbox) return;

    setAddonState(card, !checkbox.checked);
  }

  function initAddonCards() {
    const cards = document.querySelectorAll(".lr-addon-card");

    cards.forEach((card, index) => {
      if (card.dataset.addonInit === "true") return;
      card.dataset.addonInit = "true";

      if (!card.dataset.addonKey) {
        card.dataset.addonKey = card.dataset.upsellVariantId || `addon-${index}`;
      }

      const checkbox = card.querySelector(".js-addon-check");
      const button = card.querySelector(".js-addon-toggle");
      if (!checkbox || !button) return;

      setAddonState(card, checkbox.checked);

      card.addEventListener("click", (e) => {
        if (
          e.target.closest(".js-addon-toggle") ||
          e.target.closest(".js-addon-check") ||
          e.target.closest(".lr-addon-card__checklabel") ||
          e.target.closest(".lr-addon-info-btn")
        ) return;

        toggleAddon(card);
      });

      button.addEventListener("click", (e) => {
        e.stopPropagation();
        toggleAddon(card);
      });

      checkbox.addEventListener("change", (e) => {
        e.stopPropagation();
        setAddonState(card, checkbox.checked);
      });
    });
  }

  initAddonCards();

  let pendingMainAdd = false;

  document.addEventListener("click", (e) => {
    const btn = e.target.closest('button[name="add"]');
    if (!btn) return;

    const form = btn.closest("form[action^='/cart/add']");
    if (!form || !form.closest('section[id^="MainProduct-"]')) return;

    pendingMainAdd = true;
  });

  const origFetch = window.fetch;
  window.fetch = async (...args) => {
    const response = await origFetch(...args);

    try {
      const url = typeof args[0] === "string" ? args[0] : args[0]?.url || "";

      if (pendingMainAdd && url.includes("/cart/add") && response.ok) {
        pendingMainAdd = false;

        const qty = getMainQty();
        const selected = [...document.querySelectorAll('.lr-addon-card[data-selected="true"]')];

        for (const card of selected) {
          const variantId = getAddonVariantId(card);

          await origFetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              items: [{ id: variantId, quantity: qty }]
            })
          });
        }
      }
    } catch (err) {
      console.warn("Addon fetch watcher error:", err);
    }

    return response;
  };

  const modal = document.getElementById("lr-addon-modal");
  if (!modal) return;

  const titleEl = modal.querySelector(".lr-modal__title");
  const descEl = modal.querySelector(".lr-modal__description");
  const imageEl = modal.querySelector(".lr-modal__image");
  const imageWrap = modal.querySelector(".lr-modal__image-wrap");
  const closeBtn = modal.querySelector(".lr-modal__close");
  const overlay = modal.querySelector(".lr-modal__overlay");
  const modalAddonBtn = modal.querySelector(".js-modal-addon-toggle");
  const modalCloseBtnAlt = modal.querySelector(".js-modal-close-btn");

 function closeModal() {
  modal.classList.remove('open');
  document.body.classList.remove('lr-modal-open');
}

  document.querySelectorAll(".lr-addon-info-btn").forEach((btn) => {
    btn.addEventListener("click", (event) => {
      event.preventDefault();
      event.stopPropagation();

      const card = btn.closest(".lr-addon-card");
      if (!card) return;

      modal.dataset.activeAddonCard = card.dataset.addonKey;

      titleEl.textContent = btn.dataset.title || "";
      descEl.innerHTML = btn.dataset.description || "";

      if (btn.dataset.image) {
        imageEl.src = btn.dataset.image;
        imageEl.alt = btn.dataset.title || "";
        imageWrap.style.display = "";
      } else {
        imageEl.src = "";
        imageEl.alt = "";
        imageWrap.style.display = "none";
      }

      const selected = card.querySelector(".js-addon-check")?.checked;
      modalAddonBtn.textContent = selected ? "Remove" : "Add";
      modalAddonBtn.classList.toggle("lr-addon-card__btn--added", selected);

      modal.classList.add("open");
      document.body.classList.add('lr-modal-open');
    });
  });

  modalAddonBtn?.addEventListener("click", () => {
    const activeKey = modal.dataset.activeAddonCard;
    const card = document.querySelector(`.lr-addon-card[data-addon-key="${activeKey}"]`);
    if (!card) return;

    toggleAddon(card);
    closeModal(); // 👈 add this
  });

  closeBtn?.addEventListener("click", closeModal);
  overlay?.addEventListener("click", closeModal);
  modalCloseBtnAlt?.addEventListener("click", closeModal);
});